module.exports = __webpack_public_path__ + "img/contacted.333ba9ee.svg";